import { RATES, MONTHS } from "../data/rates.js";
import { round2 } from "./format.js";

export const remainingMonths = (m) => {
  const entry = MONTHS.find((x) => x[0] === m);
  return entry ? entry[2] : 12;
};

export function truckTax(truck, month) {
  if (truck.suspended) return 0;
  const r = RATES[truck.cat]?.[truck.logging ? 1 : 0] ?? 0;
  const rem = remainingMonths(month);
  return rem === 12 ? r : round2((r * rem) / 12);
}

export function totals(trucks, month) {
  const taxable = trucks.filter((t) => !t.suspended);
  const suspended = trucks.filter((t) => t.suspended);
  const line2 = round2(taxable.reduce((s, t) => s + truckTax(t, month), 0));
  const line3 = 0; // additional tax (amended/weight worksheet) - not computed in this local/demo prototype
  const line4 = line2 + line3;
  const line5 = 0; // credits - not computed in this local/demo prototype
  const line6 = line4 - line5;
  return {
    reported: trucks.length,
    taxable: taxable.length,
    suspended: suspended.length,
    line2,
    line3,
    line4,
    line5,
    line6,
  };
}
